import React from 'react'
import { Link, graphql } from 'gatsby'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import Layout from "../components/Layout"
import hot_wtr_sys from "../assets/images/hot_water_system.jpg"

class AboutPageIndex extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')    

    return (
      <Layout location={this.props.location} >
        <div style={{ background: '#fff' }}>
          <Helmet title={siteTitle} />
          <div className='general_header aboutus_header'style={{color:'#ffffff'}} />          
          <div className="page_wrapper"  style={{minHeight:'65vmin'}}>
            <h1 className="section-headline">About</h1>
            
            <p>Aquaflow QLD offer a diverse range of expert and reliable plumbing and gas fitting services to Dysart and surrounding areas. We take pride in our professional approach to customers and aim to provide a service above all expectation.</p>
            <div className="generalpage_img_left" style={{minHeight:'60vmin'}}>            
              <img src={hot_wtr_sys} />
            </div>              
              <p>We have been part of the community for over 10yrs and are committed to ensuring there is always a top-quality plumbing service available whenever you need it.</p>
              <p>Whether it's a blocked drain, leaking pipes, a new hot water system installation, complete renovation or a large scale commercial project, Aquaflow QLD can help.</p>
              <p>Aquaflow QLD has created a longstanding, trusted relationship with their clients throughout Dysart over the years. With our 24x7 emergency call out service, we're there when you need!</p>
              <p>Call us Today.</p>
            
            <hr style={{border: '1px solid #05adeb'}}/>
          </div>          
        </div>
      </Layout>
    )
  }
}

export default AboutPageIndex

export const pageQuery = graphql`
  query AboutPageIndexQuery {
    site {
      siteMetadata {
        title
      }
    }    
  }
`
